import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";
const apiUrl = process.env.REACT_APP_API


export const getBitacorasPorTurno = async (fecha) => {
    try {
        const res = await api.get(apiUrl + `/monitor/bitacoras-turno/get-notas-hoy?fecha=${fecha}`);
        return res.data;
    }
    catch (error) {
        console.log("error", error);
    }
}
export const crearReportePorTurno = async (params) => {
    try {
        const res = await api.post(apiUrl + `/monitor/bitacoras-turno/agregar-reporte`,params);
        return res.data;
    }
    catch (error) {
        console.log("error", error);
    }
}
export const getReportes = async (params) => {
    try {
        const res = await api.get(apiUrl + `/monitor/bitacoras-turno/get-reportes?fecha_inicio=${params.fecha_inicio}&fecha_fin=${params.fecha_fin}`);
        return res.data;
    }
    catch (error) {
        console.log("error", error);
    }
}
export const updateReporte = async (params) => {
    try {
        const res = await api.patch(apiUrl + `/monitor/bitacoras-turno/update-reportes`, params);
        return res.data;
    }
    catch (error) {
        console.log("error", error);
    }
}